var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// External dependencies
import { useContext, useEffect } from 'react';
import { AppBar, Toolbar, IconButton, Box, Grid, } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { LoginOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AvatarSG, ButtonSG, LanguageSG, SGLogo2SG, } from '../components';
import { CLIENT_ENDPOINTS, MULTILANGUAGE, ENDPOINTS, LOG_LEVELS, SERVICES } from '../constants';
import { UserContext, getAuthHeader } from '../auth';
import { axiosClient } from '../axios';
const lngs = Object.values(MULTILANGUAGE);
;
/**
 * Header
 * @param {HeaderProps} props
 */
export const Header = function (props) {
    const user = useContext(UserContext);
    const { t, i18n } = useTranslation();
    // Output language
    const { outputLanguage, setOutputLanguage } = props;
    // Handle drawer toggle
    const { handleDrawerToggle } = props;
    // Use React Router Dom navigate
    const navigate = useNavigate();
    /**
     * Handle Sign in action
     */
    const handleSignIn = () => {
        navigate(`${CLIENT_ENDPOINTS.SIGN_IN}`);
    };
    /**
     * Handle logo click
     */
    const handleLogoClick = () => {
        try {
            // Navigate to home
            navigate('/');
        }
        catch (err) {
            toast.error('Something went wrong. We are figuring it out.');
        }
        ;
    };
    //Load usage
    useEffect(() => {
        const getUsage = () => __awaiter(this, void 0, void 0, function* () {
            try {
                if (!user) {
                    return;
                }
                // Get auth header
                const authHeader = yield getAuthHeader(user);
                // Get current month, year
                const now = new Date();
                const month = now.getMonth() + 1;
                const year = now.getFullYear();
                const headers = Object.assign(Object.assign({}, authHeader), { 'Accept-Language': i18n.language });
                // Get usage
                const res = yield axiosClient.get(`${process.env.SERVER_URL}${ENDPOINTS.USAGE}${ENDPOINTS.GET_USAGE}?month=${month}&year=${year}`, { headers });
            }
            catch (err) {
                axiosClient.post(`${process.env.LOGGER_SERVER_URL}${ENDPOINTS.LOGGER}${ENDPOINTS.LOG}`, {
                    level: LOG_LEVELS.ERROR,
                    logMessage: `Header, getUsage, ${err === null || err === void 0 ? void 0 : err.message}`,
                    metadata: {
                        env: process.env.ENV,
                        service: SERVICES.BILLING,
                        userId: user === null || user === void 0 ? void 0 : user.uid,
                        email: user === null || user === void 0 ? void 0 : user.email,
                        userAgent: navigator === null || navigator === void 0 ? void 0 : navigator.userAgent,
                    },
                });
            }
            ;
        });
        getUsage();
    }, [user]);
    return (_jsx(AppBar
    // AppBar
    , Object.assign({ 
        // AppBar
        sx: {
            backgroundColor: 'transparent',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            border: 'none',
            boxShadow: 'none',
        } }, { children: _jsx(Toolbar, Object.assign({ sx: {
                '&': {
                    paddingLeft: '1rem',
                    paddingRight: '1rem',
                    minHeight: '4rem',
                },
            } }, { children: _jsxs(Grid, Object.assign({ container: true, columnSpacing: 0, sx: { alignItems: 'center' } }, { children: [_jsx(Grid, Object.assign({ item: true }, { children: _jsx(IconButton
                        // Drawer button
                        , Object.assign({ 
                            // Drawer button
                            color: "primary", "aria-label": "Drawer button", edge: "start", onClick: handleDrawerToggle, sx: { display: { md: 'none' } } }, { children: _jsx(MenuIcon, {}) })) })), _jsx(Grid, Object.assign({ item: true, xs: true, sx: { display: 'flex' } }, { children: _jsx(Box
                        // Logo block
                        , Object.assign({ 
                            // Logo block
                            sx: {
                                '&:hover': {
                                    cursor: 'pointer',
                                },
                                display: {
                                    md: 'inline-flex',
                                    xs: 'none',
                                },
                            }, onClick: handleLogoClick }, { children: _jsx(SGLogo2SG, { sx: { width: '3.5rem', height: '1.4375rem' } }) })) })), _jsx(Grid, Object.assign({ item: true, sx: { margin: user ? 0 : '0 0.5rem 0 0' } }, { children: _jsx(LanguageSG, { outputLanguage: outputLanguage, setOutputLanguage: setOutputLanguage }) })), _jsxs(Grid, Object.assign({ item: true, sx: { display: user ? 'none' : 'block' } }, { children: [_jsx(ButtonSG
                            // Desktop Login button
                            , Object.assign({ 
                                // Desktop Login button
                                xstyles: {
                                    display: { xs: 'none', sm: 'inline-flex' },
                                    width: '120px',
                                }, onClick: handleSignIn, "aria-label": "Sign In button", variant: "contained" }, { children: t('Log in') })), _jsx(IconButton
                            // Mobile Login button
                            , Object.assign({ "aria-label": "Sign In button", onClick: handleSignIn, sx: {
                                    display: {
                                        xs: 'inline-flex',
                                        sm: 'none',
                                    }
                                } }, { children: _jsx(LoginOutlined, { sx: { color: '#191C1A' } }) }))] })), _jsx(Grid, Object.assign({ item: true, sx: {
                            display: {
                                md: user ? 'block' : 'none',
                                xs: 'none',
                                margin: '0 0 0 0.5rem',
                            }
                        } }, { children: _jsx(AvatarSG, {}) }))] })) })) })));
};
